module.exports = __webpack_public_path__ + "img/checklist_new.a414b7f2.png";